"use client"

import { useState, useEffect, useRef } from "react"
import type { MousePosition } from "../types"
import { mouseStore } from "../mouseStore"

/**
 * Returns a live-updating mouse position that re-renders the consumer on every
 * animation frame (RAF-throttled). Uses the shared mouseStore singleton, so no
 * additional window.mousemove listener is added.
 *
 * For zero-render position access, read mouseStore.x / mouseStore.y directly.
 */
export const useMousePosition = () => {
  const [mousePosition, setMousePosition] = useState<MousePosition>({ x: 0, y: 0 })
  const rafRef = useRef<number | null>(null)

  useEffect(() => {
    return mouseStore.subscribe(() => {
      if (rafRef.current === null) {
        rafRef.current = requestAnimationFrame(() => {
          setMousePosition({ x: mouseStore.x, y: mouseStore.y })
          rafRef.current = null
        })
      }
    })
  }, [])

  return typeof window !== "undefined" ? mousePosition : { x: 0, y: 0 }
}
